import * as R from 'ramda'
import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import PropTypes from 'prop-types'

import { useI18n } from '@rushplay/i18n'

import * as Icons from '../icons'
import { NavigationLink, PageNavigation } from '../page-navigation'

export function LiveCasinoNavigation(props) {
  const { category } = ReactRouter.useParams()
  const i18n = useI18n()
  const location = ReactRouter.useLocation()

  React.useEffect(() => {
    props.onUpdateCategory(category)
  }, [category])

  const search = (
    <NavigationLink key="search" to="/live-casino/search">
      <Icons.Search /> {i18n.translate('page-navigation.search')}
    </NavigationLink>
  )

  const categories = [
    'discover',
    'roulette',
    'blackjack',
    'baccarat',
    'game-shows',
    'other',
  ]

  const navigationItems = R.map(category => {
    const type = R.toLower(category)

    return {
      label: `live-casino.categories.${type}`,
      to: `/live-casino/${type}`,
    }
  }, categories)

  const items = R.map(
    item => (
      <NavigationLink key={item.to} to={item.to}>
        {i18n.translate(item.label)}
      </NavigationLink>
    ),
    navigationItems
  )

  return (
    <ReactRouter.Switch>
      <ReactRouter.Redirect
        exact
        from="/live-casino"
        to={{
          pathname: R.path(['to'], R.head(navigationItems)),
          search: location.search,
        }}
      />
      <ReactRouter.Route>
        <PageNavigation
          items={[search, ...items]}
          header="live-casino"
          withSearch
        />
      </ReactRouter.Route>
    </ReactRouter.Switch>
  )
}

LiveCasinoNavigation.propTypes = {
  onUpdateCategory: PropTypes.func.isRequired,
}
